import { Flex } from 'antd';

import { $$$ } from '@suntex.core/text';
import { asPath } from '@suntex.core/text/extensions';
import { isPlayerLoginType } from '@suntex.fim/auth';
import { useAuth } from '@suntex.fim/auth/react';
import { createGetHref } from '@suntex.fim/hub';
import { Button } from '@suntex.fim/ui';

import { useNavigationContext } from '../../NavigationContext';
import { usePlayerContext } from '../../context';
import { useModuleNavigation } from '../../navigation';

export interface ContentModuleActionsProps {
  href: string;
  label?: string;
}

export function ContentModuleActions({
  href,
  label,
}: ContentModuleActionsProps) {
  const { isPreview } = usePlayerContext();
  const { login } = useAuth();
  const { navigateToModule } = useModuleNavigation();
  const { previewModulesPath } = useNavigationContext();

  const showPreview = !!login && !isPlayerLoginType(login.loginType);
  // Rewrite before appending preview=true: getHref skips hrefs already containing "preview".
  const baseHref = isPreview
    ? (createGetHref(true, previewModulesPath)(href) ?? href)
    : href;
  const previewHref = $$$(baseHref, asPath()).withParams({
    preview: 'true',
  }).$$;

  return (
    <Flex gap={8} justify="center">
      {!isPreview && (
        <Button
          aria-label={label ? `Play ${label}` : undefined}
          onClick={() => navigateToModule(href)}
        >
          Play
        </Button>
      )}
      {showPreview && (
        <Button
          aria-label={label ? `Preview ${label}` : undefined}
          size="small"
          onClick={() => navigateToModule(previewHref)}
        >
          Preview
        </Button>
      )}
    </Flex>
  );
}
